// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3gcNJ","legacyBtn":"MutateMid_legacyBtn__1TqEJ"};